var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"sub-nav"},[_vm._l((_vm.navBars),function(nav,index){return _c('li',{key:index,on:{"click":function($event){_vm.goRouter(nav.path)}}},[_c('a',{attrs:{"href":"javascript:;"}},[_vm._v(_vm._s(nav.label)+">")])])}),_c('li',[_c('a',{attrs:{"href":"javascript:;"}},[_vm._v(_vm._s(_vm.componentName))])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3347a07e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SubNav.vue
// module id = null
// module chunks = 